import { render, staticRenderFns } from "./ReviewItemRestaurant.vue?vue&type=template&id=6227af34&scoped=true&"
import script from "./ReviewItemRestaurant.vue?vue&type=script&lang=js&"
export * from "./ReviewItemRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItemRestaurant.vue?vue&type=style&index=0&id=6227af34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227af34",
  null
  
)

export default component.exports